export default __webpack_public_path__ + "static/media/CoffeeMug3.1b3f0f10.png";